import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import NoDataContainer from '../../../../../../components/NoDataContainer';
import TableGrid from '../../../../../../components/TableGrid';
import { TableData, transformMatrixData } from './dynamicMatrixDataTable.utils';

export interface Props {
  data?: any[];
  translation?: Map<string, string> | { [key: string]: string };
  title: string;
  translationsScope: string;
  showCurrency?: boolean;
}

const DynamicMatrixDataTable: React.FC<Props> = ({
  data,
  translation,
  title,
  translationsScope,
  showCurrency,
}) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState<TableData | null>(null);

  useEffect(() => {
    setTableData(transformMatrixData({ data, translation }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, translation]);

  return (
    <ContentBlock title={t(`${translationsScope}:${title}`)} showCurrency={showCurrency}>
      {tableData && tableData.rows?.length ? (
        <TableGrid
          columns={tableData.columns}
          originalProps={{
            rowData: tableData.rows,
            rowModelType: 'clientSide',
            domLayout: 'autoHeight',
            defaultColDef: {
              menuTabs: [],
            },
          }}
        />
      ) : (
        <NoDataContainer />
      )}
    </ContentBlock>
  );
};

export default DynamicMatrixDataTable;
